import {ColorsType, DynamicColorsType} from "./color_models";
import {Colors as StaticColors} from "./colors-base";

let dynamicColorsStore: ColorsType = StaticColors;

export const updateDynamicColors = (newColors: DynamicColorsType) => {
  dynamicColorsStore = {
    ...StaticColors,
    primary: {...StaticColors.primary, ...newColors.primary},
    secondary: {...StaticColors.secondary, ...newColors.secondary},
    tertiary: {...StaticColors.tertiary, ...newColors.tertiary},
    neon: {...StaticColors.neon, ...newColors.neon},
  };
};

export const Colors = new Proxy(StaticColors, {
  get(target, prop) {
    return dynamicColorsStore[prop as keyof ColorsType] || target[prop as keyof ColorsType];
  },
});
